import { defineMessages } from '@formatjs/intl';

export const messages = defineMessages({
  questionsTotal: {
    id: 'quiz.summary.totalCount.questions',
    defaultMessage: 'Total: {totalCount} Questions',
  },
  flashcardsTotal: {
    id: 'quiz.summary.totalCount.flashcards',
    defaultMessage: 'Total: {totalCount} Flashcards',
  },
  questions: {
    id: 'quiz.summary.quizTypeText.questions',
    defaultMessage: '{count} Questions',
  },
  flashcards: {
    id: 'quiz.summary.quizTypeText.flashcards',
    defaultMessage: '{count} Flashcards',
  },
});
